<template>
  <div class="table-container">
    <div class="table-wrapper more-height">

      <!-- :show-select must be false for custom checkbox in custom header slot -->
      <v-data-table
          :show-select="false"
          ref="dataTable"
          :value="selected"
          @input="$emit('update:selected', $event)"

          :headers="active_headers"
          :items="items"
          item-key="id"

          class="elevation-0 table custom-table"
          :class="{'table__without-checkbox': !select_active}"
          checkbox-color="primary"
          :header-props="{ sortIcon: '$vuetify.icons.iconsort' }"
          fixed-header
          disable-pagination
          :hide-default-footer="true"
          :loading="loading"
          :loading-text="loadingItemsText"
          :no-data-text="noDataText"
          :no-results-text="noSearchResultsText"
          :options.sync="options"
          :sort-desc="sortDescending"
          :sort-by="currentSort"
          @update:options="handleOptionsUpdate"

          :search="searchInTable"
          :mobile-breakpoint="mobileBreakpoint"

          :hide-default-header="true"
      >

        <template v-slot:header="{ props }">
          <tr>
            <th 
              v-if="select_active" 
              class="custom-table__filter-col custom-table__filter-col--select-all"
            >
              <v-simple-checkbox
                :value="allSelected"
                :indeterminate="someSelected && !allSelected"
                @input="toggleSelectAll"
                color="primary"
                :ripple="false"
              ></v-simple-checkbox>
            </th>

            <th
              v-for="header in filterValidDataTableHeaders(active_headers)"
              :key="header.value"
              class="custom-table__filter-col"
              :class="{ 
                'sortable': header.sortable, 
                'sorted': isSorted(header.value),
                'custom-table__filter-col--with-filter': column_live_filter && column_live_filter[header.value]?.enabled
              }"
              :style="`width: ${header.width}px; min-width: ${header.width}px;`"
            >
                <div 
                  @click="handleSort(header, props)" 
                  :header-value="header.value"
                >{{ header.text }}</div>

                <v-icon
                  v-if="header.sortable"
                  size="12"
                  class="ml-1 sort-icon"
                  @click="handleSort(header, props)"
                  :class="{
                    'sort-asc': isSorted(header.value) && !sortDescending,
                    'sort-desc': isSorted(header.value) && sortDescending
                  }"
                >
                  $vuetify.icons.iconsort
                </v-icon>

                <template v-if="column_live_filter && column_live_filter[header.value]?.enabled && columnLiveFilters[header.value]">
              
                  <template v-if="column_live_filter[header.value].filter_type === 'BOOLEAN'">
                    <v-simple-checkbox
                      v-model="columnLiveFilters[header.value].value"
                      :ripple="false"
                      color="primary"
                      hide-details
                      class="filter-input"
                      @input="emitFilters"
                    />
                  </template>

                  <template
                    v-else-if="column_live_filter[header.value].filter_type === 'SELECT'"
                  >
                    <v-autocomplete
                      outlined
                      dense
                      solo
                      flat
                      hide-details
                      attach
                      clearable
                      append-icon=""
                      :item-text="(item) => item.label || item.name"
                      item-value="id"
                      v-model="columnLiveFilters[header.value].value"
                      :items="custom_data_linked_tables_values[column_live_filter[header.value]?.filter_model || header.name]"
                      :menu-props="{minWidth:'200'}"
                      @change="emitFilters"
                      class="filter-input"
                    >
                    </v-autocomplete>

                  </template>

                  <!-- BAT121-766: EXISTS — presence filter ("Так" → ne null / "Ні" → eq null).
                       Values 'yes'/'no' are mapped in CustomDataTab.vue → handleLiveColumnFiltersUpdate. -->
                  <template
                    v-else-if="column_live_filter[header.value].filter_type === 'EXISTS'"
                  >
                    <v-autocomplete
                      outlined
                      dense
                      solo
                      flat
                      hide-details
                      attach
                      clearable
                      append-icon=""
                      :items="[
                        { label: $t('modules.customdata.filters.filters_json.active'), value: 'yes' },
                        { label: $t('modules.customdata.filters.filters_json.not_active'), value: 'no' },
                      ]"
                      item-text="label"
                      item-value="value"
                      v-model="columnLiveFilters[header.value].value"
                      :menu-props="{minWidth:'200'}"
                      @change="emitFilters"
                      class="filter-input"
                    />
                  </template>

                  <template
                    v-else-if="
                      column_live_filter[header.value].filter_type === 'DATE' ||
                      column_live_filter[header.value].string_input?.type === 'date'
                    "
                  >
                    <DatePicker
                      v-model="columnLiveFilters[header.value].value"
                      :append-to-body="false"
                      :lang="$i18n.locale"
                      type="date"
                      valueType="YYYY-MM-DD"
                      format="DD.MM.YYYY"
                      :show-second="false"
                      @input="emitFilters"
                      class="filter-input"
                    />
                
                    <!-- <v-menu
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    attach
                    left
                    class="date-picker-menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        flat
                        dense
                        solo
                        hide-details
                        v-model="columnLiveFilters[header.value].value"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @input="emitFilters"
                        class="filter-input"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="columnLiveFilters[header.value].value"
                      no-title
                      :locale="i18n.locale"
                      scrollable
                      :first-day-of-week="1"
                      @input="emitFilters"
                    >
                    </v-date-picker>
                  </v-menu> -->
                  </template>

                  <template
                    v-else
                  >
                    <v-text-field
                      v-model="columnLiveFilters[header.value].value"
                      flat
                      dense
                      outlined
                      solo
                      hide-details
                      clearable
                      class="filter-input"
                      @input="emitFilters"
                    />
                  </template>

                </template>
            </th>
          </tr>
        </template>

        <template v-slot:item="{ item, headers, isSelected, select }">
          <tr
            :data-id="item.id"
            :style="getRowStyle(item)"
          >
              <td v-if="select_active">
                <v-simple-checkbox
                  :value="isSelected"
                  @input="select($event)"
                  color="primary"
                  :ripple="false"
                ></v-simple-checkbox>
              </td>

              <td
                v-for="( header, index ) in headers"
                :key="index"
                :style="getCellStyle(header, item)"
                :class="{
                  'column-sticky': horizontalScrollExist && header.type === 'actions'
                }"
              >
                <template
                  v-if="!header.type && !select_active"
                >
  
                </template>

                <template
                  v-else-if="header.file_upload"
                >
                  <div class="d-flex justify-center align-center position-relative">

                    <template v-if="item[header.value] && item[header.value].files">
                      <a
                        :href="file.url"
                        target="_blank"
                        v-for="(file, fileIndex) in item[header.value].files"
                        :key="fileIndex"
                        class="mr-1"
                      >
                        <v-img
                          v-if="isImage(file.name)"
                          lazy-src="https://picsum.photos/id/11/10/6"
                          height="17"
                          width="17"
                          :src="file.url"
                        ></v-img>

                        <v-icon v-else size="20" color="black3">mdi-file</v-icon>
                      </a>
                    </template>

                    <v-menu
                      offset-y
                      rounded='sm'
                      :absolute="true"
                      :allow-overflow="true"
                      nudge-bottom="0"
                      max-width="250"
                      min-width="220"
                      content-class="custom-table__file elevation-0"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          elevation="0"
                          height="36"
                          width="36"
                          min-width="auto"
                          v-bind="attrs"
                          v-on="on"
                          text
                          class="custom-table__file--btn px-0 order-1 ml-2"
                        >
                          <v-icon size="20" color="primary">mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <div class="custom-table__file--wrapper">
                          <v-list-item-group>

                            <template v-if="item[header.value] && item[header.value].files">
                              <v-chip
                                v-for="(file, fileIndex) in item[header.value].files"
                                :key="fileIndex"
                                class="custom-table__file--chip"
                                close
                                small
                                color="primary"
                                width="100%"
                                @click:close="deleteFile(file.name, item.id, header.name)"
                              >
                                <v-icon left size="18">
                                  mdi-file-link
                                </v-icon>

                                <a :href="file.url" target="_blank">
                                  {{ file.name }}
                                </a>
                              </v-chip>
                            </template>

                            <v-list-item
                              @click="openFileDialog($event)"
                              class="mt-1"
                            >
                              <v-list-item-icon>
                                <v-icon>mdi-paperclip</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>
                                {{i18n.t('modules.customdata.upload')}}
                              </v-list-item-title>
                            </v-list-item>

                            <v-file-input
                              multiple
                              v-model="uploadFiles"
                              accept="image/png, image/jpeg, image/jpg, .pdf, .doc, .docx, .xls, .xlsx"
                              :label="$t('modules.customdata.upload')"
                              v-on:change="uploadFile(item.id, $event, header.name)"
                              class="fileInput"
                              style="display: none;"
                            ></v-file-input>

                          </v-list-item-group>
                        </div>
                      </v-list>
                    </v-menu>
                  </div>
                </template>

                <template
                  v-else-if="header.display_in_table === 'image'"
                >
                  <div
                    v-if="parseFileUrls(item[header.value]).length > 0"
                    style="display: flex; flex-direction: row; justify-content: center; flex-wrap: nowrap; align-items: center; gap: 4px;"
                  >
                    <CdImageItem
                      v-for="(url, idx) in parseFileUrls(item[header.value])"
                      :key="idx"
                      :imageUrl="url"
                    />
                  </div>
                </template>

                <template
                  v-else-if="header.name === 'active'"
                >
                  <v-switch
                    inset
                    color="primary"
                    :input-value="item[header.value]"
                    @change="toggleActiveClient({user_id: item['id'], toggle: $event } )"
                  />
                </template>

                <template
                  v-else-if="header.name === 'channel'"
                >
                  <v-layout align-center justify-center>
                    <v-avatar
                      :key="formatChannelIcons(item).name"
                      size="20"
                    >
                      <img
                        :src="formatChannelIcons(item).icon"
                        :title="formatChannelIcons(item).name"
                        :alt="formatChannelIcons(item).name"
                      />
                    </v-avatar>
                  </v-layout>
                </template>

                <template
                  v-else-if="header.type === 'DATE'"
                >

                  <!-- <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip 
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        @mouseenter="handleHover"
                      >
                        {{ formatDate(item[header.value], true) }}
                      </v-chip>
                    </template>
                    <span>{{ formatDate(item[header.value]) }}</span>
                  </v-tooltip> -->

                  <DynamicTableCell
                    :key="item.id"
                    :value="item[header.value]"
                    :itemId="item.id"
                    :itemName="header.value"
                    :itemType="header.type"
                  />

                </template>

                <template
                  v-else-if="header.type === 'actions' && hasTableActionsColumnItems"
                  :class="{
                    'column-sticky': horizontalScrollExist
                  }"
                >
                  <v-layout align-center justify-center>
                    <v-btn
                      v-if="!isSystemViewHidden('table-actions-edit-btn')"
                      icon
                      color="green"
                      class="mt-1"
                      data-system-view="table-actions-edit-btn"
                      @click="editItem(item.id)"
                      :title="i18n.t('modules.customdata.entity.edit')"
                    ><v-icon small>$iconedit</v-icon></v-btn>
                    <!-- <v-btn
                      icon
                      color="red"
                      class="mt-1"
                      @click="deleteItem(item.id)"
                      :title="i18n.t('modules.customdata.entity.delete')"
                    ><v-icon small>$icondelete</v-icon></v-btn> -->

                    <span
                      v-if="$route.path.split('/').includes('ap') && !isSystemViewHidden('table-actions-audit-btn')"
                      :title="getAuditStartButtonTitle(item)"
                    >
                      <v-btn
                        icon
                        :color="isAuditStartDisabled(item) ? undefined : 'teal'"
                        class="mt-1"
                        data-system-view="table-actions-audit-btn"
                        :disabled="isAuditStartDisabled(item)"
                        @click="startAudit(item)"
                      ><v-icon size="20">mdi-clipboard-check</v-icon></v-btn>
                    </span>

                    <CustomDataMacroRun
                      v-if="macros_params?.bot_id && macros_params?.single && !isSystemViewHidden('table-actions-processes-btn')"
                      :key="item.id"
                      data-system-view="table-actions-processes-btn"
                      :macros_params="macros_params"
                      :item_obj="item"
                    />

                  </v-layout>
                </template>

                <template
                  v-else
                >
                  <DynamicTableCell
                    :key="item.id"
                    :value="item[header.value]"
                    :itemId="item.id"
                    :itemName="header.value"
                    :itemType="header.type"
                    :itemEditable="header.non_editable"
                    :itemDisplayType="header.display_type"
                    :itemClickAction="header.click_action"
                    :itemAssociation="header.column_from_association"
                    :headerData="header"
                    :highlight_color="highlightColorByRules(header, item)"
                    :item_obj="item"
                    :entity_field="entity_fields[header.value]"
                    :entity_fields="entity_fields"
                    @open-edit="editItem"
                  />
                </template>
              </td>
            </tr>
        </template>

        <template v-slot:body.append="{headers}">
          <tr
            v-if="propTotalRow"
            class="total-row"
          >
            <td 
              v-for="(header, index) in headers" 
              :key="index"
              class="total-col"
              :class="{'total-col--hidden': header.value == 'data-table-select' || header.value == 'id' || header.value == 'actions'}"
            >
              <template
                v-if="header.total_sum && header.value !== 'data-table-select' && header.value !== 'id' && header.value !== 'actions'"
              >
                {{getColumnSumByHeader(header)}}
              </template>
            </td>
          </tr>
        </template>

      </v-data-table>
    </div>

    <div
        class="table-pagination"
        v-if="selected.length < 1"
    >
      <div class="text-caption mr-5">
        <span class="table-pagination__mobile-hide">{{ $t('modules.customdata.table.pagination.showed') }}</span> {{ itemsLength }} <span class="table-pagination__mobile-hide">{{ $t('modules.customdata.table.pagination.items') }}</span>
      </div>

      <v-spacer></v-spacer>

      {{ /* Select Per Page */ }}
      <div class="d-flex align-center">
        <!-- <div class="text-body-2 mr-2">{{ $t('modules.customdata.table.pagination.rows_per_page') }}:</div> -->
        <v-select
            item-text="name"
            item-value="value"
            v-model="selectDefaultPerPage"
            :items="itemsPerPage"
            @change="resetPagination"
            dense
            outlined
            height="32"
            hide-details
            class="select-per-page"
        ></v-select>
      </div>
      {{ /* end Select Per Page */ }}

      <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="(pageCount >= 3) ? '5' : '0'"
          @input="handlePageChange"
          circle
      ></v-pagination>
    </div>

    <div
      class="table-pagination"
      v-else
    >
      <div class="text-caption">
        {{ $t('modules.customdata.table.pagination.selected') }}: {{ selected.length }} {{ $t('modules.customdata.table.pagination.items') }}
      </div>
      <v-spacer />
    </div>

  </div>
</template>

<script>
import i18n from "@/lang/i18n"
import { mapGetters } from "vuex";
import Vue from "vue";
import axios from "axios";
import _ from 'lodash'

import DynamicTableCell from "@/modules/CustomData/components/DynamicTableCell.vue";
import CdImageItem from "@/modules/CustomData/views/customdata/NewComponents/CdImageItem.vue";
import { parseFileUrls } from "@/modules/CustomData/utils/image.js";
import {
	hasApFinishPhoto,
	isApShiftCancelled,
	isApShiftOpenForAudit,
	parseApPlannedStartDateTime,
} from '@/modules/CustomData/utils/auditShiftGuard.js';
import CustomDataMacroRun from "@/modules/CustomData/components/MacroRun.vue"

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/uk';
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/de';

const telegramIcon = require('@/assets/logo-telegram.svg');
const viberIcon = require('@/assets/logo-viber.svg');
const messengerIcon = require('@/assets/logo-messenger.svg');
const whatsappIcon = require('@/assets/logo-whatsapp.svg');
const widgetIcon = require('@/assets/logo-kwizbot.svg');

export default {
  name: "DynamicTable",

  components: {
    CdImageItem,
    DynamicTableCell,
    CustomDataMacroRun,
    DatePicker
  },

  props: {
    columns_data: {
      type: Array,
      default: () => [],
    },
    select_active: {
      type:Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    // selectedHeaders: {
    //   type: Array,
    //   default: () => [],
    // },
    loadingItemsText: {
      type: String,
      default: i18n.t("modules.customdata.table.loading_items"),
    },
    noDataText: {
      type: String,
      default: i18n.t("modules.customdata.table.no_data_text"),
    },
    noSearchResultsText: {
      type: String,
      default: i18n.t("modules.customdata.table.no_search_results"),
    },
    itemsLength: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: true,
    },

    defaultPerPage: {
      type: Number,
      default: 5,
    },
    itemsPerPage: {
      type: Array,
      default: () => [],
    },

    pageCount: {
      type: Number,
      default: 0,
    },

    defaultSort: {
      type: String || Array,
      default: () => '' || []
    },

    searchInTable: {
      type: String,
      default: '0',
    },

    propTotalRow: {
      type:Boolean,
      default: false
    },

    mobileBreakpoint: {
      type: Number,
      default: 0,
    },

    multiple_entity: {
      type: String,
      require: true
    },

    entity_fields: {
      type: Object,
      default: () => {},
    },

    ui_table_stylization: {
      type: Object,
      default: () => {},
    },

    macros_params: {
      type: Object,
      default: () => {},
    },

    column_live_filter: {
      type: Object,
      default: () => {},
    }
  },

  data: () => ({
    // selectedRows: [],
    page: 1,
    itemsCount: 0,
    options:{},
    i18n,
    currentSort: '',
    sortDescending: true,
    uploadFiles: [],
    horizontalScrollExist: false,

    handleMouseMove: null,

    sortState: {},
    columnLiveFilters: {},
    // Reactive clock for audit button enable when planned start arrives without reload
    auditGuardNowMs: Date.now(),
  }),
  mounted() {

    // BAT121-766: one-time cleanup of the legacy global key; hydrate column live filters
    // from the per-model key (`cd_live_column_filters__{bot_id}__{model_name}`) so reload
    // restores values for the current model only, without touching other models.
    this._cleanupLegacyColumnLiveFiltersKey();
    const storedLiveFilters = this._readColumnLiveFiltersFromStorage();
    if (storedLiveFilters && typeof storedLiveFilters === 'object') {
      this.columnLiveFilters = storedLiveFilters;
      this.$emit('update:columnLiveFilters', { ...this.columnLiveFilters });
    }

    this.checkForHorizontalScroll();
    this._auditGuardTimeoutId = null;
    this._scheduleAuditGuardTick();
    this._auditGuardVisibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        this._scheduleAuditGuardTick();
      }
    };
    document.addEventListener('visibilitychange', this._auditGuardVisibilityHandler);

    this.handleMouseMove = (e) => {
      let ele = document.querySelector('.table-wrapper');
      if (!ele) return;

      let rect = ele.getBoundingClientRect();
      let isMouseOver = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;

      if (isMouseOver) {
        let distanceWidth = rect.right - e.clientX;
        let distanceHeight = rect.bottom - e.clientY;

        distanceWidth < 20 && distanceWidth > 0 ? ele.classList.add('more-width') : ele.classList.remove('more-width');
        // distanceHeight < 20 && distanceHeight > 0 ? ele.classList.add('more-height') : ele.classList.remove('more-height');
      } else {
        ele.classList.remove('more-width');
        // ele.classList.remove('more-height');
      }
    };

    document.addEventListener("mousemove", this.handleMouseMove);
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.handleMouseMove);
    this._clearAuditGuardTick();
    if (this._auditGuardItemsScheduleDebounce) {
      clearTimeout(this._auditGuardItemsScheduleDebounce);
      this._auditGuardItemsScheduleDebounce = null;
    }
    if (this._auditGuardVisibilityHandler) {
      document.removeEventListener('visibilitychange', this._auditGuardVisibilityHandler);
      this._auditGuardVisibilityHandler = null;
    }
  },

  updated() {
    this.checkForHorizontalScroll();
  },
  watch: {
    options: {
      handler (val, valBefore) {
        if (valBefore?.page)
          this.$emit("sortOptions", this.options);
      },
      deep: true,
    },

    active_headers: {
      handler(newHeaders) {
        if (!newHeaders || !Array.isArray(newHeaders)) return;
        newHeaders.forEach(header => {
          if (!header || !header.value) return;
          if (!this.sortState[header.value]) {
            this.$set(this.sortState, header.value, 0);
          }

          const cfg = this.column_live_filter?.[header.value];
          if (!cfg || !cfg.enabled) return;

          // BAT121-766: mirror the reconcile logic from the `column_live_filter`
          // watcher — preserve the user's `value` while keeping metadata in sync
          // with the current JSON UI config, and reset `value` when `filter_type`
          // changes so the routing in `handleLiveColumnFiltersUpdate` matches.
          const existing = this.columnLiveFilters[header.value];
          const newType = cfg.filter_type === 'SELECT' ? 'STRING' : cfg.filter_type || 'STRING';
          const defaultValue = cfg.filter_type === 'BOOLEAN' ? false : '';
          const typeChanged = existing && existing.type !== newType;
          const nextValue = existing && !typeChanged ? existing.value : defaultValue;

          this.$set(this.columnLiveFilters, header.value, {
            value: nextValue,
            type: newType,
            string_input: cfg.string_input || null,
            condition: cfg.filter_condition,
            filter_model: cfg.filter_model || null,
            outside_model: cfg.outside_model || null,
            outside_extract_field: cfg.outside_extract_field || null,
          });
        });
      },
      immediate: true,
    },

    column_live_filter: {
      handler(newFilter, oldFilter) {
        if (!newFilter || Object.keys(newFilter).length === 0) {
          // BAT121-766: only clear displayed state; keep per-model LS intact so that
          // toggling the config back on a model restores its previously entered values.
          if (Object.keys(this.columnLiveFilters).length > 0) {
            this.columnLiveFilters = {};
            this.$emit('update:columnLiveFilters', {});
          }
          return;
        }

        // BAT121-766: seed templates for EVERY `enabled` config entry, not only for
        // columns currently present in `active_headers`. Column chooser may hide a
        // newly-configured column (saved `columns_data_activated` has no entry → it
        // defaults to `active: false` in `_customDataColumnsActualization`), which
        // excluded it from seeding until the user reordered/activated it via DnD and
        // forced a Vuex commit. With direct iteration over the config keys, the
        // template's `v-if="... columnLiveFilters[header.value]"` already resolves
        // the moment the column is shown — no DnD dance required.
        //
        // Additionally reconcile metadata (`type`, `string_input`, `condition`,
        // `filter_model`, `outside_model`) on every fire so that changing
        // `filter_type` in the JSON UI (e.g. BOOLEAN → EXISTS) is not defeated by
        // stale per-model LS state. `value` is preserved if `type` stays the same;
        // on an incompatible type change we reset it to the new default, otherwise
        // `handleLiveColumnFiltersUpdate` would route the wrong filter shape to the
        // backend (e.g. `{ ap_break: { eq: "yes" } }` with `type: "BOOLEAN"`).
        Object.keys(newFilter).forEach((key) => {
          if (!key) return;
          const cfg = newFilter[key];
          if (!cfg || !cfg.enabled) return;

          const existing = this.columnLiveFilters[key];
          const newType = cfg.filter_type === 'SELECT' ? 'STRING' : cfg.filter_type || 'STRING';
          const defaultValue = cfg.filter_type === 'BOOLEAN' ? false : '';
          const typeChanged = existing && existing.type !== newType;
          const nextValue = existing && !typeChanged ? existing.value : defaultValue;

          this.$set(this.columnLiveFilters, key, {
            value: nextValue,
            type: newType,
            string_input: cfg.string_input || null,
            condition: cfg.filter_condition,
            filter_model: cfg.filter_model || null,
            outside_model: cfg.outside_model || null,
            outside_extract_field: cfg.outside_extract_field || null,
          });
        });
      },
      immediate: true,
    },

    // BAT121-766: persist outgoing model's filters under its own per-model LS key and
    // hydrate the incoming model's filters from its key, so each CustomData model keeps
    // its own column-live-filter state across navigation and page reloads.
    multiple_entity: {
      handler(newModel, oldModel) {
        if (!newModel || newModel === oldModel) return;

        if (this.emitFilters && typeof this.emitFilters.cancel === 'function') {
          this.emitFilters.cancel();
        }

        if (oldModel && Object.keys(this.columnLiveFilters).length > 0) {
          this._writeColumnLiveFiltersToStorage(oldModel);
        }

        this.columnLiveFilters = {};
        const stored = this._readColumnLiveFiltersFromStorage(newModel);
        if (stored && typeof stored === 'object') {
          this.columnLiveFilters = stored;
        }
        this.$emit('update:columnLiveFilters', { ...this.columnLiveFilters });
        this._scheduleAuditGuardTick();
      },
    },

    items: {
      handler() {
        // Debounce: parent may replace items array during list load; avoid timer thrash.
        if (this._auditGuardItemsScheduleDebounce) {
          clearTimeout(this._auditGuardItemsScheduleDebounce);
        }
        this._auditGuardItemsScheduleDebounce = setTimeout(() => {
          this._auditGuardItemsScheduleDebounce = null;
          this._scheduleAuditGuardTick();
        }, 300);
      },
    },

  },
  computed: {
    ...mapGetters([
      'custom_data_columns_data',
      'custom_data_default_columns_data',
      'custom_data_linked_tables_values',
      'engine_settings',
      'bot_settings',
      'isSystemViewHidden',
    ]),
    // showHeaders() {
    //   return (this.selectedHeaders)
    //     ? this.selectedHeaders.filter((s) => s.active === true)
    //     : this.headers;
    // },

    // selectVal: {
    //   get() {
    //     return this.selectedRows;
    //   },
    //   set(val) {
    //     this.selectedRows = val;
    //     this.$emit("selectedData", val);
    //   },
    // },

    /**
     * @name selectDefaultPerPage
     * @description v-model for select Per Page Items
     */
    selectDefaultPerPage: {
      get() {
        return this.defaultPerPage;
      },
      set(value) {
        this.$emit("change-default-per-page", value);
      },
    },

    active_headers() {
      let data = []
      if(this.columns_data?.length) {
        data = this.columns_data
      } else if(this.custom_data_columns_data?.length) {
        data = this.custom_data_columns_data
      }

      //TODO: need to optimize - consider adding memoization for large arrays to avoid recomputing on every dependency change
      let arr = data.filter((c) => c && c.active === true && c.value)
      arr = _.sortBy(arr, 'position')
      // BAT121-709: hide actions column if all action buttons are hidden
      if (!this.hasTableActionsColumnItems) {
        arr = arr.filter((h) => !(h.type === 'actions' && h.value === 'actions'))
      }
      // BAT121-765: id/createdAt — list API strips sortable on these; ensure sort UI matches backend ORDER BY
      arr = arr.map((h) => (
        h.type !== 'actions' && [ 'id', 'createdAt' ].includes(h.value) ? { ...h, sortable: true } : h
      ))
      return arr
    },

    hasTableActionsColumnItems() {
      return !this.isSystemViewHidden('table-actions-edit-btn')
        || (this.$route.path.split('/').includes('ap') && !this.isSystemViewHidden('table-actions-audit-btn'))
        || (this.macros_params?.bot_id && this.macros_params?.single && !this.isSystemViewHidden('table-actions-processes-btn'))
    },

    defaultSortOptions() {
      if (Array.isArray(this.defaultSort)) {
        return {
          sortBy: this.defaultSort[0],
          descending: this.sortDescending,
        };
      } else {
        return {
          sortBy: this.defaultSort,
          descending: this.sortDescending,
        };
      }
    },

    allSelected() {
      return this.items.length > 0 && this.selected.length === this.items.length;
    },

    someSelected() {
      return this.selected.length > 0 && this.selected.length < this.items.length;
    },
  },

  methods: {
    parseFileUrls,

    /**
     * Disable Audit when finish photo, cancelled, or planned start not arrived.
     * Uses reactive auditGuardNowMs so the button enables when start time arrives without reload.
     */
    isAuditStartDisabled(item) {
      return !isApShiftOpenForAudit(item, new Date(this.auditGuardNowMs));
    },

    getAuditStartButtonTitle(item) {
      if (this.isAuditStartDisabled(item)) {
        return i18n.t('modules.customdata.audit.audit_shift_inactive');
      }
      return i18n.t('modules.customdata.audit.start_btn');
    },

    _isApAuditRoute() {
      return this.$route?.path?.split('/')?.includes('ap') === true;
    },

    _clearAuditGuardTick() {
      if (this._auditGuardTimeoutId != null) {
        clearTimeout(this._auditGuardTimeoutId);
        this._auditGuardTimeoutId = null;
      }
    },

    /**
     * Refresh reactive clock and schedule the next tick at the soonest future planned start
     * among visible rows (so Audit enables without page reload).
     */
    _scheduleAuditGuardTick() {
      this._clearAuditGuardTick();
      this.auditGuardNowMs = Date.now();

      if (!this._isApAuditRoute()) {
        return;
      }

      const nowMs = this.auditGuardNowMs;
      let nextAt = null;

      for (const item of (this.items || [])) {
        if (hasApFinishPhoto(item) || isApShiftCancelled(item)) {
          continue;
        }
        const planned = parseApPlannedStartDateTime(item);
        if (!planned) {
          continue;
        }
        const plannedMs = planned.getTime();
        if (plannedMs > nowMs && (nextAt === null || plannedMs < nextAt)) {
          nextAt = plannedMs;
        }
      }

      if (nextAt === null) {
        return;
      }

      // +250ms past planned start; cap at 1h then reschedule for later starts
      const delay = Math.min(Math.max(nextAt - Date.now() + 250, 250), 60 * 60 * 1000);
      this._auditGuardTimeoutId = setTimeout(() => {
        this._scheduleAuditGuardTick();
      }, delay);
    },

    /**
     * @description reset Pager on @change perPage v-select
     */
    resetPagination() {
      this.page = 1;
    },

    /**
     * @name handlePageChange
     * @param value
     * @description call on input/change for pagination and send to parent
     */
    handlePageChange(value) {
      this.$emit("change-page", value);
    },

    startAudit(value) {
      this.$emit('start-audit', value)
    },

    editItem(value) {
      this.$emit('edit-item', value)
    },
    deleteItem(value) {
      this.$emit('delete-item', value)
    },

    toggleActiveClient(value) {
      this.$emit('toggle_active-client', value)
    },

    formatChannelIcons(user) {
      switch (user.channel) {
        case 'telegram':
          return {
            icon: telegramIcon,
            name: 'Telegram',
          };

        case 'viber':
          return {
            icon: viberIcon,
            name: 'Viber',
          };

        case 'facebook':
          return {
            icon: messengerIcon,
            name: 'Facebook',
          };

        case 'whatsapp':
          return {
            icon: whatsappIcon,
            name: 'Whatsapp',
          };

        case 'widget':
          return {
            icon: widgetIcon,
            name: 'Widget',
          };
        default:
          return {
            icon: widgetIcon,
            name: 'Widget',
          };
      }
    },

    getColumnSumByHeader(header) {
      const sum = this.custom_data_default_columns_data.find((c) => c.value === header.value)?.sum;
      const multiplier = Math.pow(10, 2);
      return Math.round(sum * multiplier) / multiplier || '';
    },

    handleOptionsUpdate(newOptions) {
      if (!newOptions.sortBy?.length || !newOptions.sortDesc?.length) {
        this.currentSort = [this.defaultSortOptions.sortBy];
        this.sortDescending = [this.defaultSortOptions.descending];
      }
    },

    
    /**
     * handle sort table for custom header slot
    */
    handleSort(header, props) {
      if (!header.sortable) return;

      const value = header.value;
      const currentState = this.sortState[value] || 0;
      const nextState = (currentState + 1) % 3;
      this.$set(this.sortState, value, nextState);

      if (nextState === 0) {
        this.currentSort = this.defaultSortOptions.sortBy;
        this.sortDescending = this.defaultSortOptions.descending;
        this.options = {
          ...this.options,
          sortBy: Array.isArray(this.currentSort) ? this.currentSort : [this.currentSort],
          sortDesc: Array.isArray(this.sortDescending) ? this.sortDescending : [this.sortDescending],
        };
      } else {
        this.currentSort = value;
        this.sortDescending = nextState === 2;
        this.options = {
          ...this.options,
          sortBy: [value],
          sortDesc: [this.sortDescending],
        };
      }
    },
    isSorted(value) {
      return Array.isArray(this.currentSort) ? this.currentSort.includes(value) : this.currentSort === value;
    },

    emitFilters: _.debounce(function () {
      // BAT121-766: write to the per-model key (see _buildColumnLiveFiltersKey); never
      // share a single global key across models, otherwise switching a model would
      // overwrite siblings.
      this._writeColumnLiveFiltersToStorage();
      this.$emit('update:columnLiveFilters', { ...this.columnLiveFilters });
    }, 2000),

    // BAT121-766: localStorage helpers — per-model key `cd_live_column_filters__{bot_id}__{model_name}`.
    // Any `modelName` override is used to write/read state for a specific (e.g. outgoing) model
    // during `multiple_entity` watcher; default resolves from the current `multiple_entity` prop.
    _buildColumnLiveFiltersKey(modelName) {
      const botId = this.bot_settings?.active_id;
      const model = (modelName != null && modelName !== '') ? modelName : this.multiple_entity;
      if (botId == null || botId === '' || !model) return null;
      return `cd_live_column_filters__${botId}__${model}`;
    },

    _readColumnLiveFiltersFromStorage(modelName) {
      const key = this._buildColumnLiveFiltersKey(modelName);
      if (!key) return null;
      try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },

    _writeColumnLiveFiltersToStorage(modelName) {
      const key = this._buildColumnLiveFiltersKey(modelName);
      if (!key) return;
      try {
        localStorage.setItem(key, JSON.stringify(this.columnLiveFilters));
      } catch (e) {
        // Safari Private mode / quota errors are silent on purpose — live filters
        // simply won't persist there, but the rest of the app stays functional.
      }
    },

    _removeColumnLiveFiltersFromStorage(modelName) {
      const key = this._buildColumnLiveFiltersKey(modelName);
      if (!key) return;
      try {
        localStorage.removeItem(key);
      } catch (e) {
        // ignore storage errors
      }
    },

    _cleanupLegacyColumnLiveFiltersKey() {
      // BAT121-766: on first mount after deploy, migrate the legacy single-key state
      // (`cd_live_column_filters`) into the per-model key for the currently active
      // model, then drop the legacy key. This preserves user's filters on reload.
      try {
        const legacyRaw = localStorage.getItem('cd_live_column_filters');
        if (legacyRaw == null) return;
        const perModelKey = this._buildColumnLiveFiltersKey();
        if (perModelKey && localStorage.getItem(perModelKey) == null) {
          try {
            localStorage.setItem(perModelKey, legacyRaw);
          } catch (e) {
            // migration best-effort; legacy removal still proceeds below
          }
        }
        localStorage.removeItem('cd_live_column_filters');
      } catch (e) {
        // ignore storage errors
      }
    },

    clearLiveFilterFields() {
      // BAT121-766: parent calls this synchronously during `multiple_entity` change, when
      // the LS key already points to the *new* model. Touching LS here would wipe the
      // incoming model's persisted values, so this method only resets in-memory display.
      Object.keys(this.columnLiveFilters).forEach(key => {
        const filter = this.columnLiveFilters[key];
        if (filter) {
          if (filter.type === 'BOOLEAN') {
            this.$set(this.columnLiveFilters[key], 'value', false);
          } else {
            this.$set(this.columnLiveFilters[key], 'value', '');
          }
        }
      });
    },

    clearAllLiveFilters() {
      this.columnLiveFilters = {};
      // BAT121-766: remove only the current model's key; BAT121-729 "reset all filters"
      // wipes every per-model key for the bot separately from CustomDataTab.
      this._removeColumnLiveFiltersFromStorage();

      // BAT121-766: re-seed templates from the full config (not only `active_headers`)
      // so that columns currently hidden in the column chooser still have their state
      // ready — the filter appears the moment the user makes the column visible.
      const cfg = this.column_live_filter || {};
      Object.keys(cfg).forEach((key) => {
        if (!key) return;
        const entry = cfg[key];
        if (!entry || !entry.enabled) return;
        this.$set(this.columnLiveFilters, key, {
          value: entry.filter_type === 'BOOLEAN' ? false : '',
          type: entry.filter_type === 'SELECT' ? 'STRING' : entry.filter_type || 'STRING',
          string_input: entry.string_input || null,
          condition: entry.filter_condition,
          filter_model: entry.filter_model || null,
          outside_model: entry.outside_model || null,
          outside_extract_field: entry.outside_extract_field || null,
        });
      });

      this.$emit('update:columnLiveFilters', {});
    },

    openFileDialog(event) {
      event.target.closest('.v-list-item-group').querySelector('.fileInput label').click();
    },

    /**
     * Upload file
     * @method uploadFile
     *
     * */
    async uploadFile(id, data, field_name) {

      if (!data) return false;

      let success = false;

      const token = Vue.$cookies.get('token_e')
      const engine_url = this.engine_settings.active_url;
      const bot_id = this.bot_settings.active_id;
      const url = `${engine_url}/kw/custom_modules/${this.multiple_entity}/update_file/${id}`;
      const request = new FormData();

      let i = 0;
      for (let file of data) {
        request.set('files[' + i + ']', file, file.name);
        i++;
      }

      request.append('field_name', field_name);

      this.$store.dispatch('updateAjaxDialog', [true, true]);
      await axios.post(url, request, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "X-CSRF-TOKEN": token
        },
        params: {
          bot_id: bot_id,
        },
      })
        .then( async (response) => {
            this.$store.dispatch('updateAjaxDialog', [ true, false, i18n.t('modules.customdata.success'), i18n.t('modules.customdata.uploaded') ]);

            if ( response?.data?.status === 'success' ) {
              this.$emit('update-list');
              this.uploadFiles = [];
              success = true;
            }
          },
          (err) => {
            this.$store.dispatch('updateAjaxDialogError', [ err,  i18n.t("common.error"),  i18n.t("common.error_get") ]);
          }
        );

      return success;
    },

    /**
     * Delete file
     * @method deleteFile
     *
     * */
    async deleteFile(file_name, id, field_name) {

      if (!file_name) return false;

      let success = false;

      const token = Vue.$cookies.get('token_e')
      const engine_url = this.engine_settings.active_url;
      const bot_id = this.bot_settings.active_id;
      const url = `${engine_url}/kw/custom_modules/${this.multiple_entity}/delete_file/${id}`;

      const request = {
        field_name: field_name,
        file_name: file_name
      };

      this.$store.dispatch('updateAjaxDialog', [true, true]);
      await axios.post(url, request, {
        headers: {
          'Content-Type': 'application/json',
          "X-CSRF-TOKEN": token
        },
        params: {
          bot_id: bot_id,
        },
      })
        .then( async (response) => {
            this.$store.dispatch('updateAjaxDialog', [ true, false, i18n.t('modules.customdata.success'), i18n.t('modules.customdata.deleted') ]);

            if ( response?.data?.status === 'success' ) {
              this.$emit('update-list');
              success = true;
            }
          },
          (err) => {
            this.$store.dispatch('updateAjaxDialogError', [ err,  i18n.t("common.error"),  i18n.t("common.error_get") ]);
          }
        );

      return success;
    },

    isImage(file) {
      const fileName = file.toLowerCase();
      return (fileName.endsWith('.jpg') ||
        fileName.endsWith('.jpeg') ||
        fileName.endsWith('.png') ||
        fileName.endsWith('.gif') ||
        fileName.endsWith('.bmp') ||
        fileName.endsWith('.svg'));
    },

    checkForHorizontalScroll() {
      const tableRef = this.$refs.dataTable;
      const tableEl = tableRef && tableRef.$el;
      if (!tableEl || typeof tableEl.querySelector !== 'function') return;
      const dataTable = tableEl.querySelector('.v-data-table__wrapper');
      if (!dataTable) return;

      this.horizontalScrollExist = dataTable.scrollWidth > dataTable.clientWidth;
    },

    filterValidDataTableHeaders(headers) {
      if (!headers || !Array.isArray(headers)) return [];
      return headers.filter((h) => h && h.value);
    },

    highlightColorByRules(header, item) {
      let highlight = null

      if(header?.highlight_rules?.rules?.length) {
        const rules = header.highlight_rules.rules
        let i;
        for (i = 0; i < rules.length; i++) {
          const first = rules[i]['0']
          const second = rules[i]['1']
          const action = rules[i].action
          const color = rules[i].color
          const tolerance = rules[i].tolerance

          if( item?.[first] && item?.[second] ) {

            if (header.highlight_rules.type === 'time' && tolerance !== undefined) {
              const timeToMinutes = (timeStr) => {
                const [hours, minutes] = timeStr.split(':').map(Number);
                return hours * 60 + minutes;
              };

              const startMinutes = timeToMinutes(item[first]);
              const factualStartMinutes = timeToMinutes(item[second]);
              const timeDifference = factualStartMinutes - startMinutes;

              if (timeDifference <= tolerance) {
                continue;
              }
            }

            const compare = this.$getComparator(action);

            if(compare( item?.[first], item?.[second] )) {
              highlight =  color
            }
          }
        }
      }

      return highlight
    },

    getRowStyle(item) {
      let styles = {}
      if(this.ui_table_stylization?.colorize) {
        const colorize = this.ui_table_stylization.colorize

        //set row bgColor
        if(
          colorize?.what === 'row'
          && item?.[colorize?.param_name]
        ) {
          let backgroundColor = item[colorize.param_name]

          if(colorize?.opacity) {
            backgroundColor = this.hexToRgba(backgroundColor, colorize.opacity)
          }
          styles = {...styles, backgroundColor: backgroundColor}
        }
      }

      return styles
    },
    getCellStyle(header, item) {
      let styles = {}
      if(this.ui_table_stylization?.colorize) {
        const colorize = this.ui_table_stylization.colorize

        //set cell bgColor
        if(
          colorize?.what === 'cell'
          && item?.[colorize?.param_name]
          && colorize?.field === header?.name
        ) {
          let backgroundColor = item[colorize.param_name]

          if(colorize?.opacity) {
            backgroundColor = this.hexToRgba(backgroundColor, colorize.opacity)
          }
          styles = {...styles, backgroundColor: backgroundColor}
        }
      }

      return styles
    },
    hexToRgba(hex, opacity) {
      // Remove the leading '#' if present
      hex = hex.replace('#', '');

      // Parse the hex color
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      // Return the RGBA color
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    },

    toggleSelectAll(value) {
      this.$emit('update:selected', value ? [...this.items] : []);
    }
  },

  created() {
    this.currentSort = this.defaultSortOptions.sortBy;
    this.sortDescending = this.defaultSortOptions.descending;
  },
};
</script>

<style lang="scss" scoped>
.table-container::v-deep {
  display: flex;
  flex-direction: column;
  flex: auto;
}

/* Pagination */
.table-pagination::v-deep {
  // border-top: 1px solid var(--v-gray-base);
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .select-per-page{
    max-width: 70px;
    &.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
      padding: 0 8px 0 12px;
      min-height: 32px;
    }
    &.v-select.v-input--dense .v-select__selection--comma{
      margin: 0;
      font-size: 14px;
      overflow: visible;
    }
    .v-input__append-inner{
      margin-top: 4px !important;
    }

    .v-select__selections {
      flex-wrap: nowrap;
    }
  }

  .v-pagination__item{
    box-shadow: none;
    background: none;
    min-width: 28px;
    max-height: 28px;
    border-radius: 2px;
    border: 1px solid transparent;
    background-color: transparent !important;

    &.v-pagination__item--active {
      border-color: var(--v-primary-base);

      color: var(--v-primary-base);
    }
  }

  .v-pagination {
    .v-pagination__navigation {
      background: transparent;
      box-shadow: none;
    }
  }
}
/* end Pagination */

.table-wrapper {
  height: 300px;
  flex: auto;

  &.more-width {
    ::-webkit-scrollbar {
      width: 8px;
    }

    tr td.column-sticky {
      right: -5px !important;
    }
  }

  &.more-height {
    ::-webkit-scrollbar {
      height: 12px;
    }
  }

  ::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  ::-webkit-scrollbar-track {
    background: var(--v-gray-base);
  }
  ::-webkit-scrollbar-thumb {
    background: var(--v-primary-base);
    border-radius: 2px;
  }
}
.table::v-deep {
  flex: auto;
  height: 100%;

  table {
    border-top: none;

    @media screen and (min-width: 1300px) {
      zoom: 0.9;
    }
  }

  .v-input--selection-controls__input {
    margin-right: 8px;
  }

  .v-data-table__wrapper {
    height: 100%;
  }
  th{
    border-top: 1px solid var(--v-blueHaze-base);

    /* Sort icon */
    &:not(:first-child) {
      padding-right: 27px !important;
      & > span.v-icon {
        position: absolute;
        right: 12px;
        top: 18px;

        width: 10px !important;
        height: 12px !important;

        svg {
          width: 10px !important;
          height: 12px !important;
        }
      }
    }
  }
  th, td{
    /* style for checkbox selected*/
    &:nth-child(1) {
      padding-left: 10px;
      padding-right: 2px;
    }
    &:nth-child(2) {
      padding-left: 10px;
      border-left: none;
    }
  }

  &.table__without-checkbox {
    th{
      &:first-child {
        padding-right: 27px !important;
        & > span.v-icon {
          position: absolute;
          right: 12px;
          top: 18px;

          width: 10px !important;
          height: 12px !important;

          svg {
            width: 10px !important;
            height: 12px !important;
          }
        }
      }
    }
  }
}
/* Custom table cols */
.table-col-status {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-table::v-deep {
  border-radius: 0;
  background: none;

  &.theme--light {
    table {
      background: white;
    }
  }

  table {
    border: 1px solid var(--v-blueHaze-base);
    border-top: none;
  }
  tr {
    th {
      // background-color: var(--v-gray2-base) !important;
      // white-space: nowrap;
      font-weight: 700;

    }
    td{
      &.column-sticky{
        background-color: #fff;
        position: sticky;
        right: 0;
        z-index: 1;

        &:before {
          content: "";
          width: 1px;
          height: 100%;
          background-color: #d0d4e4;
          position: absolute;
          left: -1px;
          top: 0;
        }

        .v-btn--icon.v-size--default {
          //width: auto;
        }
      }
    }
    td *:not(i, button) {
      font-size: 14px !important;
    }
    th, td {
      font-size: 14px !important;
      color: var(--v-black-base) !important;
      padding: 0 10px !important;

      &:not(:last-child) {
        border-right: 1px solid var(--v-blueHaze-base);
      }
    }
    &:first-child {

    }
    &:last-child {
      td {
        //border-bottom: 1px solid var(--v-gray-base);
      }
    }
    &:hover {
      background: var(--v-athensGray-base) !important;
    }
  }

  .v-date-picker-table td {
    padding: 0 !important;
  }

  .date-picker-menu {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    right: 0;
    top: 12px;
    z-index: 1;

    .v-menu__content {
      left: 50% !important;
      transform: translateX(-50%) !important;
    }

    .v-date-picker-table {
      height: auto !important;
      padding-bottom: 12px;
    }
  }

  .v-data-table-header {
    th {
      box-shadow: 0px 0px 25px -8px var(--v-ghost-base), inset 0 -1px 0 rgba(0, 0, 0, 0.12) !important;
    }
  }

  .total-row {
    box-shadow: 0px 2px 0px var(--v-athensGray-base), 2px 0px  0px var(--v-athensGray-base), -2px 0px 0px var(--v-athensGray-base);
    background: var(--v-athensGray-base) !important;

    td {
      border-bottom: 1px solid var(--v-blueHaze-base);

      &.total-col--hidden {
          border-bottom: none;
        }

      &:last-child:not(.total-col--hidden) {
        border-right: 1px solid var(--v-blueHaze-base);
      }
    }

    .total-col--hidden + .total-col--hidden {
      box-shadow: -2px 0px 0px var(--v-athensGray-base);
    }
  }

  .total-col {
    padding: 0 23px !important;
  }

  .custom-table__filter-col {
    position: sticky;
    top: 0;
    z-index: 2;
    text-align: left;
    line-height: 1.25;
    background-color: #fff;
    padding-bottom: 8px !important;
    padding-top: 10px !important;
    box-shadow: 0px 0px 25px -8px var(--v-ghost-base), inset 0 -1px 0 rgba(0, 0, 0, 0.12) !important;

    &:hover {
      .sort-icon {
        opacity: 1;
      }
    }

    &--select-all {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    &--with-filter {
      padding-bottom: 35px !important;
    }
  }

  .sort-icon {
    transition: all 0.3s ease;
    opacity: 0;
    position: absolute;
    right: 12px;
    top: 18px;

    &.sort-asc {
      transform: rotate(0deg);
      opacity: 1;
    }

    &.sort-desc {
      transform: rotate(180deg);
      opacity: 1;
    }
  }

  .filter-input {
    position: absolute;
    left: 5px;
    right: 5px;
    bottom: 5px;
    font-size: 14px;
    font-weight: normal;
    z-index: 1;
    width: auto;

    &.mx-datepicker {
      right: 10px;
      left: 10px;

      .mx-icon-calendar {
        color: var(--v-ghost-base);
      }

      .mx-date-row:hover {
        background: none !important;
      }
    }

    .mx-input {
      height: 25px;
      border-color: var(--v-blueHaze-base);
      box-shadow: none;
      padding-left: 5px;
      color: var(--v-black-base);
    }

    .v-input__control {
      min-height: auto !important;
      height: 25px;
    }

    .v-input__slot {
      padding: 0 5px 0 7px !important;
      min-height: auto !important;
      height: 25px;
    }

    fieldset {
      border-color: var(--v-blueHaze-base);
    }

    &.v-autocomplete.v-select.v-input--is-focused input {
      min-width: auto !important;
    }

    &.v-input--is-focused {
      fieldset {
        border-color: var(--v-primary-base);
      }
    }


    &.v-simple-checkbox {
      left: 10px;

      .v-icon {
        color: var(--v-blueHaze-base);
      }
    }

    .v-input__icon--clear {
      width: 10px;
      min-width: 10px;

      button {
        font-size: 18px;
      }
    }

    .v-menu__content {
      margin-top: 8px;
    }

  }
}

.dynamic-table::v-deep {
  position: relative;

  table {
    border-radius: 10px;

    th {
      &:first-child {
        border-top-left-radius: 10px;
      }

      &:last-child {
        border-top-right-radius: 10px;
      }
    }
  }

  .table-wrapper {
    border-radius: 10px;
    overflow: hidden;
  }

  .table-pagination {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateY(calc(-100% - 10px));
    padding-top: 0;
  }
}
@media screen and (max-width: 767px) {
  .table-pagination__mobile-hide {
    display: none;
  }
  .table-pagination .v-pagination__item {
    min-width: 20px;
  }
  .table-pagination::v-deep {
    .v-pagination__more {
      width: 20px;
    }
    .v-pagination__item {
      min-width: 20px;
      padding: 0 2px;
    }
    .v-pagination__navigation {
      width: 20px;
    }
  }
}
</style>

<style lang="scss">
.custom-table__file {
  border: 1px solid var(--v-gray-base);

  .custom-table__file--chip {
    max-width: calc(100% - 16px);
    margin-left: 8px;
    margin-bottom: 4px;

    .v-chip__content {
      justify-content: flex-end;

      a {
        overflow: hidden;
        display: inline-flex;
        justify-content: flex-end;
        color: white;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

  }

  .custom-table__file--btn {

    .v-ripple__container {
      display: none;
    }

    .v-icon {
      opacity: 0.7;
    }

    &:hover,
    &:focus
    {
      .v-icon {
        opacity: 1;
      }
    }
  }
}
</style>
